





































































import Vue from "vue";
import { ScrappedTypeServiceProxy } from "@/service-proxies/app-v2/qc.service-proxies";
import AddorEditScrapType from "./components/AddOrEditScrapType.vue";
import ScrapReason from "./components/ScrapReason.vue";
const scrappedTypeServiceProxy = new ScrappedTypeServiceProxy();
export default Vue.extend({
  name: "ScrapType",
  components: {
    AddorEditScrapType,
    ScrapReason,
  },
  data() {
    return {
      tableData: [],
      filter: "",
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
      editForm: {},
      addType: false,
      modalVisible: false,
      columns: [
        {
          title: this.$t("page_authority_action"),
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 198,
        },
        {
          title: this.$t("page_scrap_type_code"),
          dataIndex: "code",
          key: "code",
          width: 200,
        },
        {
          title: this.$t('page_scrap_type'),
          dataIndex: "name",
          key: "name",
          width: 120,
        },
        {
          title: this.$t('remark'),
          dataIndex: "remark",
          key: "remark",
          width: 120,
        },
      ],
      currentType: {},
      selectedRowKeys: [],
      visiable: false,
    };
  },
  created() {
    this.loadTableData();
    this.pagination.onChange = (currentPage) => {
      this.pagination.current = currentPage;
      this.loadTableData();
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys }: any = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: []) => {
          this.selectedRowKeys = selectedRowKeys;
          console.log(122, this.selectedRowKeys);
        },
      };
    },
  },

  methods: {
    rowClick(item: any) {
      return {
        on: {
          click: (row: any) => {
            console.log("111", item);
            this.currentType = item;
            // this.detailshow = true;
          },
        },
      };
    },
    loadTableData() {
      scrappedTypeServiceProxy
        .getPageScrappedReason(
          this.pagination.current,
          this.filter,
          this.pagination.pageSize
        )
        .then((res) => {
          console.log(111, res);
          this.pagination.total = res.total;
          this.tableData = res.records || [];
          if (res.records.length > 0) {
            this.currentType = this.tableData[0]
          } else {
            this.currentType = {}
          }
        });
    },
    groupDelete(ids) {
      scrappedTypeServiceProxy.deleteScrappedType(ids).then((res) => {
        this.$message.info(this.$t('delete_success'));
        this.loadTableData();
      });
    },
    openEditModal(record) {
      this.editForm = record;
      console.log("recode", record);
      this.modalVisible = true;
      this.addType = false;
    },
    handleCancel(flag) {
      this.modalVisible = false;
      if (flag) {
        this.loadTableData();
      }
    },
  },
});
